import {Stack, Typography} from '@mui/material';
import {SVGIcon} from '@resurs-internal/mui';
import Error from 'assets/images/error.svg';
import React from 'react';
import {useTranslate} from '../../hooks';

export const ErrorView: React.FC<{
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}> = ({title, subtitle, children}) => {
  const translate = useTranslate();
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Stack spacing={2} alignItems={'center'}>
        <SVGIcon name={Error} alt={translate('common.warning')} size={'xl'} />
        <Typography variant={'subtitle1'} textAlign={'center'}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant={'body1'} textAlign={'center'}>
            {subtitle}
          </Typography>
        )}
        {children}
      </Stack>
    </div>
  );
};
